// Redirect all Shop store requests to the BL store
// Use top so that the theme editor can still display pages
window.top.location.href = "https://www.babylist.com/store";